export const appReleaseFormModel = {
  formId: 'createAppReleaseForm',
  formField: {
    version: {
      name: 'version',
      label: 'Versión (Ej: 1.2.0)',
      requiredErrorMsg: 'La versión es obligatoria',
    },
    application: {
      name: 'application',
      label: 'Aplicación',
      requiredErrorMsg: 'Debes seleccionar una aplicación',
    },
    features: {
      name: 'features',
      label: 'Novedades',
      requiredErrorMsg: 'Debes incluir al menos una novedad',
    },
    type: {
      name: 'type',
      label: 'Tipo de Actualización',
      requiredErrorMsg: 'El tipo de actualización es obligatorio',
    },
  },
};

export const featureFormModel = {
  moduleName: {
    name: 'moduleName',
    label: 'Módulo (Ej: Usuarios, Reservas)',
    requiredErrorMsg: 'El nombre del módulo es obligatorio',
  },
  title: {
    name: 'title',
    label: 'Título de la mejora',
    requiredErrorMsg: 'El título es obligatorio',
  },
  description: {
    name: 'description',
    label: 'Descripción de la novedad',
    requiredErrorMsg: 'La descripción es obligatoria',
  },
  type: {
    name: 'type',
    label: 'Tipo',
    requiredErrorMsg: 'El tipo de novedad es obligatorio',
  },
};
